export const cursorURL = {
    defaultCursorURL: 'url(game-assets/boot-load-assets/cursors-assets/cursor-pointer.cur), pointer',
    interactiveCursorURL: 'url(game-assets/boot-load-assets/cursors-assets/cursor-hand.cur), pointer'
}

export const GameSpecifications:{
    name: string;
    continueGame: boolean;
    currentPeriodIndex: number;
    decisionPeriodIds: string[];
    currentPeriodId: string;
    currentDecisionIndex: number;
    decisionIds: string[];
    currentDecisionId: string;
    appPath: string;
    gameOver: boolean;
    canvasWidth: number;
    canvasHeight: number;
} = {
    name: 'GIRHA',
    continueGame: false,
    currentPeriodIndex: 0,
    decisionPeriodIds: [],
    currentPeriodId: '',
    currentDecisionIndex: 0,
    decisionIds: [],
    currentDecisionId: '',
    appPath: '',
    gameOver: false,
    canvasWidth: 1366,
    canvasHeight: 761
}

export const gameRouterLink: {routerLink: any} = {
    routerLink: null
}

export const servicioGraficaAC: {serviceArea: any} = {
    serviceArea: null
}

export const servicioPuntajes: {serviceScore: any} = {
    serviceScore: null
}

export const gameStatus: {
    status: string;
    conectionStatus: boolean;
    gameMusic: any;
    isMusicPlaying: boolean;
    isSoundMuted: boolean;
} = {
    status: 'mainScene',
    conectionStatus: false,
    gameMusic: null,
    isMusicPlaying: false,
    isSoundMuted: true,
}

export const lifecycleSpecifications = {
    0 : {
        idLifecycle: 0,
        nameAssets: 'fase-1-background',
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 55,
            objectHeight: 29,
            objectPositionX: 384,
            objectPositionY: 522
        }
    },
    1 : {
        idLifecycle: 1,
        nameAssets: 'fase-2-background',
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 83,
            objectHeight: 83,
            objectPositionX: 388,
            objectPositionY: 493
        }
    },
    2 : {
        idLifecycle: 2,
        nameAssets: 'fase-3-background',
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 173,
            objectHeight: 185,
            objectPositionX: 384,
            objectPositionY: 441
        }
    },
    3 : {
        idLifecycle: 3,
        nameAssets: 'fase-4-background',
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 248,
            objectHeight: 255,
            objectPositionX: 396,
            objectPositionY: 407
        }
    },
    4 : {
        idLifecycle: 4,
        nameAssets: 'fase-5-background',
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 340,
            objectHeight: 400,
            objectPositionX: 377,
            objectPositionY: 336
        }
    },
}
